import { useRef } from "react";
import { PropTypes } from "prop-types";
import { TextField, InputAdornment, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

function SearchBar({ value, onSearchChange, onInmediateChange }) {
  const searchDebounceRef = useRef(null);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    

    onInmediateChange(searchValue);

    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      onSearchChange(searchValue);
    }, 500);
  };

  return (
    <Grid container sx={{ width: "100%" }}>
      <TextField
        size="small"
        variant="outlined"
        label="Buscar"
        value={value}
        onChange={handleSearchChange}
        placeholder="Buscar..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
        sx={{
          flexGrow: 1,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 1,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ccc",
            },
            "&:hover fieldset": {
              borderColor: "#999",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1976d2",
            },
          },
        }}
      />
    </Grid>
  );
}

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onInmediateChange: PropTypes.func.isRequired,
};

export default SearchBar;
